module.exports = __webpack_public_path__ + "5c3ccc4aac630cb7799b6cf6a396b488.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/registered_charity_logo.png
// module id = NM9i
// module chunks = 5